import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const EvaluativeTestsStyled = styled.div`
  .title-container {
    padding: 30px 60px 16px;
    display: flex;
    flex-wrap: wrap;
  }

  .button-custom {
    border-radius: 10px;
    color: ${tokens.color.text.onDark};
  }
  
  /* Divisor alineado con el contenido (antes «inset» empezaba desplazado y llegaba al borde) */
  .page-divider {
    margin: 0 60px;
  }

  .date-container {
    padding: 16px 60px 24px;
  }

  .description-section {
    display: block;
    margin-bottom: 16px;
    color: ${tokens.color.text.tertiary};
    font-size: 14px;
    font-weight: 400;
  }

  /* Filtros a la izquierda; toggle Activas / Todas a la derecha */
  .tests-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;

    .tests-filters,
    .tests-actions {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
    }
  }

  /* Rejilla de tarjetas compactas alineada con el padding de la página (antes 70 px por lado y
     tarjetas de 450 px fijos) */
  .cards-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
    padding: 0 60px 30px;

    .cards-empty {
      grid-column: 1 / -1;
    }
  }

  .MuiTypography-body1 {
    font-family: "Poppins";
    font-weight: 500;
  }

  .alert-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
  }

`
export default EvaluativeTestsStyled
